import {Component, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {TableModule} from 'primeng/table';
import {Checkbox} from 'primeng/checkbox';
import {FormsModule} from '@angular/forms';
import {PermissionId} from '../../../../../../../api';
import {Loader} from '../../../../../../components/loader/loader';
import {PermissionRow} from '../../models/permission-row';
import {PermissionLabelPipe} from '../../pipes/permission-label.pipe';

@Component({
  selector: 'elcia-permission-matrix',
  imports: [TableModule, TranslatePipe, Checkbox, FormsModule, Loader, PermissionLabelPipe],
  templateUrl: './permission-matrix.html',
})
export class PermissionMatrix {
  permissions = input<PermissionId[]>([]);
  rows = input<PermissionRow[]>([]);
  isLoading = input<boolean>(false);
  onToggle = output<{userAccountId: string; permission: PermissionId}>();

  protected has(row: PermissionRow, permission: PermissionId): boolean {
    return row.permissions.includes(permission);
  }

  protected toggle(row: PermissionRow, permission: PermissionId): void {
    this.onToggle.emit({userAccountId: row.userAccountId, permission});
  }
}
